import Safe from './Safe';

import style from './styles.module.scss';

const LoginAnimation = () => {
  return (
    <div className={style['animation-wrapper']}>
      <div className={style.container}>
        <div className={style.key}></div>
        <Safe
          isAnimated
          isLoggingIn
        />
      </div>
    </div>
  );
};

export default LoginAnimation;
